import * as types from './actionTypes';
import * as selectors from './selectors';
import * as api from '../../../../common/api';

export const fetchWorkOrders = customerId => ({
    types: [types.FETCH_WORK_ORDERS_REQUEST, types.FETCH_WORK_ORDERS_SUCCESS, types.FETCH_WORK_ORDERS_FAILURE],
    apiCall: () => api.getWorkOrders(customerId)
});

export const setActiveOrder = (orderId) => ({
    type: types.SET_ACTIVE_WORK_ORDER,
    orderId   
});

export const setPreviousOrder = (orderId) => ({
    type: types.SET_PREVIOUS_WORK_ORDER,
    orderId   
});

export const setActiveTab = (selectedTabName) => ({
    type: types.SET_ACTIVE_TAB,
    selectedTabName,
});